import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import fontWeight from '../fontWeight';
var fontFamily = '"Aspira Webfont"';
var cdnLocation = 'https://c.cheggcdn.com/f';
var fontData = [{
  name: 'Regular',
  cdn: '30B57C_60_0',
  weight: fontWeight.normal
}, {
  name: 'Medium',
  cdn: '30B57C_5D_0',
  weight: fontWeight.medium,
  displayStrategy: 'block' // used for logos, so we don't want a flash of unstyled text

}, {
  name: 'Bold',
  cdn: '30B57C_52_0',
  weight: fontWeight.bold
}, {
  name: 'Heavy',
  cdn: '30B57C_57_0',
  weight: fontWeight.heavy
}];
var fontFace = '';

for (var ii = 0; ii < fontData.length; ii++) {
  var _fontData$ii = fontData[ii],
      name = _fontData$ii.name,
      cdn = _fontData$ii.cdn,
      weight = _fontData$ii.weight,
      displayStrategy = _fontData$ii.displayStrategy;
  fontFace = "\n    ".concat(fontFace, "\n    @font-face {\n      font-family: ").concat(fontFamily, ";\n      src: local(\"Aspira ").concat(name, "\"),\n           url(\"").concat(cdnLocation, "/woff2/").concat(cdn, ".woff2\") format(\"woff2\"),\n           url(\"").concat(cdnLocation, "/woff/").concat(cdn, ".woff\") format(\"woff\");\n      font-weight: ").concat(weight, ";\n      font-style: normal;\n      font-display: ").concat(displayStrategy || 'fallback', ";\n    }\n  ");
}
/**
 * Preloads WOFF2 webfonts only -- browsers that need WOFF don't support
 * `link[rel="preload"]`.
 */


export var WebfontAssetPreload = function WebfontAssetPreload() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, fontData.map(function (_ref, index) {
    var cdn = _ref.cdn;
    return /*#__PURE__*/React.createElement("link", {
      key: index,
      rel: "preload",
      href: "".concat(cdnLocation, "/woff2/").concat(cdn, ".woff2"),
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    });
  }));
};
export var WebfontLoader = createGlobalStyle(_templateObject(), fontFace);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/WebfontLoader/index.js
// module id = 1038
// module chunks = 12